"use strict";

exports.__esModule = true;
exports.getStatisticsPointsOptions = void 0;
var _valueFormatters = require("../valueFormatters");
var STATISTICS_FONT_SIZE = 10;
var getStatisticsPointsOptions = exports.getStatisticsPointsOptions = function getStatisticsPointsOptions(statistics, valueFormatter) {
  if (valueFormatter === void 0) {
    valueFormatter = _valueFormatters.defaultValueFormatter;
  }
  var markPoints = {
    symbol: "arrow",
    symbolSize: 15,
    symbolRotate: 180
  };
  var data = [];
  if (statistics != null && statistics.minShow) {
    data.push({
      type: "min",
      name: "Min",
      label: {
        formatter: function formatter(_ref) {
          var value = _ref.value;
          return "Min: " + valueFormatter(value);
        },
        position: "bottom",
        fontSize: STATISTICS_FONT_SIZE
      }
    });
  }
  if (statistics != null && statistics.maxShow) {
    data.push({
      type: "max",
      name: "Max",
      label: {
        formatter: function formatter(_ref2) {
          var value = _ref2.value;
          return "Max: " + valueFormatter(value);
        },
        position: "top",
        fontSize: STATISTICS_FONT_SIZE
      }
    });
  }
  markPoints.data = data;
  return markPoints;
};